import NotificationWithInfo from './NotificationWithInfo';
import { useNotification } from '../../app-store/notification/useNotification';

const NotificationContainer = () => {
    const { removeNotificationWithInfo, notification: notificationContext } = useNotification();

    function onCloseNotificationWithInfo() {
        removeNotificationWithInfo();
    }

    function onConfirmNotificationWithInfo() {
        if (notificationContext) {
            notificationContext.callback?.(notificationContext?.dataRaw);
        }

        removeNotificationWithInfo();
    }

    return (
        <>
            {notificationContext ? (
                <NotificationWithInfo
                    infoNotification={notificationContext}
                    onClose={onCloseNotificationWithInfo}
                    onConfirm={onConfirmNotificationWithInfo}
                />
            ) : null}
        </>
    );
};

export default NotificationContainer;
